import Ajax from "Utils/ajax";
export const getEventList = (data) => Ajax.post('hr/getEventList',data); 
export const deleteEvent = (data) => Ajax.post('hr/deleteEvent',data);
export const addUpdateEventList = (data) => Ajax.post('hr/addUpdateEventList',data);